import themeKym from "../utils/themes/ThemeKym";

const FooterContainer = (props) => {
  const classesKym = themeKym();
  return <div className={classesKym.footerContainer}>{props.children}</div>;
};

export default FooterContainer;
